/** ELF program brand tokens (aligned with Projects/ELF.tsx). */
export const ELF_TEAL = '#008578';
export const ELF_LIME = '#D2D755';
export const ELF_GRADIENT = `linear-gradient(135deg, ${ELF_LIME} 0%, ${ELF_TEAL} 100%)`;

export const elfPrimaryButtonSx = {
  bgcolor: ELF_TEAL,
  color: '#fff',
  '&:hover': {
    bgcolor: '#006b61',
  },
} as const;

export const elfOutlinedButtonSx = {
  borderColor: ELF_TEAL,
  color: ELF_TEAL,
  '&:hover': {
    borderColor: '#006b61',
    bgcolor: 'rgba(0, 133, 120, 0.06)',
  },
} as const;

export const elfTextButtonSx = {
  color: ELF_TEAL,
  '&:hover': {
    bgcolor: 'rgba(210, 215, 85, 0.12)',
  },
} as const;
